<template>
  <section
    id="pro-plus"
    class="padding-top-5xl padding-bottom-2xl"
  >
    <div class="row margin-bottom-4xl">
      <div class="column-12 text-center">
        <h2
          class="text-uppercase size-md with-anchor"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--fa-md-gravy)"
        >
          <anchor-link
            anchor="#pro-plus"
            link-color="gravy"
            anchor-name="New Icon Packs"
          />
          Hot Off the Griddle
        </h2>
        <h1 class="h2 margin-y-md">
          New Icon Packs
          <span
            class="tag teal margin-left-xs size-2xs"
            style="--tag-border-radius: var(--border-radius-sm); --tag-padding: var(--spacing-3xs) var(--spacing-2xs) var(--spacing-2xs) var(--spacing-sm)"
            ><span style="font-size: var(--font-size-xs); font-weight: var(--font-weight-black); letter-spacing: var(--letter-spacing-3xl)">Pro+</span></span
          >
        </h1>
        <p class="line-length-xl margin-auto">
          Entirely new, visually unique "small batch" icon packs designed in collaboration with world-class icon designers.
          <site-link
            :to="{ name: 'plans', query: { plans: 'plus' } }"
            @click.native="$posthog.capture('upgrade_link_click', { context: 'home_view' })"
            >Available now in all Pro+ plans</site-link
          >!
        </p>
      </div>
    </div>
    <div class="row">
      <div class="column-12">
        <div
          class="message teal align-middle display-flex margin-bottom-2xl"
          style="--message-border-width: 0"
        >
          <font-awesome-icon
            :icon="$v7.solid.faShapes"
            size="2xl"
            class="decorative"
          />
          <div class="tablet:display-flex align-between align-middle">
            <p class="margin-bottom-0 margin-x-2xl">
              Each Pro+ icon pack contains a curated selection of the <strong>200 most common icons</strong> needed for app and website design.
            </p>
            <site-link
              v-if="!isActiveProPlus"
              :to="{ name: 'plans' }"
              class="button teal margin-top-xl margin-bottom-2xs tablet:margin-top-0"
              style="flex-shrink: 0"
            >
              <font-awesome-icon
                :icon="$v7.solid.faTag"
                size="xl"
                class="margin-right-2xs"
              />
              Upgrade to Pro+
            </site-link>
          </div>
        </div>
        <icon-pack-cards
          collection-name="pro-plus-exclusive-collection"
          more-soon
          style="--card-margin-bottom: 0; gap: var(--spacing-2xl) 0"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import IconPackCards from '../components/IconPackCards'
  import AnchorLink from '../components/AnchorLink'

  export default {
    name: 'ProPlus',

    components: {
      IconPackCards,
      AnchorLink
    },

    props: {
      isSignedIn: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('subscriptions', ['currentSubscription']),

      isActiveProPlus() {
        const hasProPlus = this.$permits.has('accessToProPlus') && this.$dt.active

        return hasProPlus
      }
    }
  }
</script>
